module.exports = __webpack_public_path__ + "static/media/corporate-catering-3.27e66cb4.jpg";